import React, {Component} from 'react';
import {Link} from 'react-router-dom'

class EstateMinComponent extends Component {

    render(){
        const estate = this.props.estate;

        let prix = 0;
        if (estate.prix) {
            prix = parseInt(estate.prix._text).toLocaleString(
                undefined, // leave undefined to use the browser's locale,
                // or use a string like 'en-US' to override it.
                { minimumFractionDigits: 0 }
            );
        }
        // TODO: why return?
        if (prix === 0) return ''


        return (
            <div className="property clearfix wow fadeInUp delay-03s">
                <div className="col-lg-5 col-md-5 col-sm-5 col-xs-12 col-pad">
                    <Link to={`/estate/${estate.id._text}`}>
                        <div className="property-img">
                            <div className="property-tag button sale">{estate.type_offre ? estate.type_offre._cdata : ""}</div>
                            {estate.images ?
                                <img src={estate.images.image[0]._cdata} alt="fp-list" className="img-responsive hp-1" />
                                :
                                ''
                            }
                        </div>
                    </Link>
                </div>
                <div className="col-lg-7 col-md-7 col-sm-7 col-xs-12 property-content ">
                    <h3 className="property-price">€{prix}</h3>
                    <h1 className="title">
                        <Link   className="propertyTitleLink"
                                style={{color: window.customColor}}
                                to={`/estate/${estate.id._text}`}>{estate.titre ? estate.titre._cdata.trim() : "-"}</Link>
                    </h1>
                    <h3 className="property-address">
                        <Link to={`/estate/${estate.id._text}`}>
                            <i className="fas fa-location-arrow fwicons"></i>{estate.ville ? (estate.ville._attributes.humanName ? estate.ville._attributes.humanName : this.capitalizeFirstLetter(estate.ville._cdata)) : "-"}
                        </Link>
                    </h3>
                    <ul className="facilities-list clearfix">
                        <li>
                            <i className="fas fa-th fwicons"></i>
                            <span>{estate.surface_habitable ? estate.surface_habitable._cdata : "-"} {estate.surface_habitable._attributes ? estate.surface_habitable._attributes.unit : "m"}<sup>2</sup></span>
                        </li>
                        {estate.chambres ? <li>
                            <i className="fa fa-bed fwicons"/>
                            <span>{estate.chambres._text} Chambres</span>
                        </li> : ''}
                        {estate.wc ? <li>
                            <i className="fas fa-toilet fwicons"></i>
                            <span> {estate.wc._text} WC</span>
                        </li> : ''}
                        {estate.parking &&  parseInt(estate.parking._text) > 0? <li>
                            <i className="fas fa-warehouse fwicons"></i>
                            <span>{estate.parking._text} Parking</span>
                        </li> : '' }
                        {estate.balcon ? <li>
                            <i className="fas fa-door-closed fwicons"></i>
                            <span> {estate.balcon._text} Balcony</span>
                        </li> : '' }
                    </ul>
                </div>
            </div>
        )

    }
}

export default EstateMinComponent;
